import { combineReducers } from "redux";

import Region from "./Region";
import Employee from "./Employee";
import Company from "./Company";
import Stand from "./Stand";

export default combineReducers({
  Region,
  Company,
  Employee,
  Stand,
});
